export default "__VITE_ASSET__B$vMpRKK__"